import { delay, put, take } from 'redux-saga/effects';
import { getType } from 'typesafe-actions';

import * as actions from './actions';
import { answerWaitingPopup, isWaitingForQuestion } from '@utils/askInPopup';
import { msUntilStill } from '@utils/calendar/markUsedCelebration';

export type EstimateQuestion =
  | ReturnType<typeof actions.openCategoryTimeDialog>
  | ReturnType<typeof actions.openNewEstimateDialog>;

/**
 * Asks an estimate question a save brought (a category's time, a book's time per page), and returns once it is
 * answered. In the popup of the session `askIn` while that waits for it, the popup turning into the question; else as
 * an overlay, once what the click set moving is still, so it never lands on another animation (Petr, 2026-10-31).
 */
export function* askEstimateQuestion(question: EstimateQuestion, askIn?: number) {
  const inPopup = isWaitingForQuestion(askIn);
  if (!inPopup) {
    const wait = msUntilStill();
    if (wait > 0) yield delay(wait);
  }
  yield put({ ...question, payload: { ...question.payload, inPopup: inPopup ? askIn : undefined } } as EstimateQuestion);
  if (inPopup) answerWaitingPopup(askIn, true);
  const category = question.type === getType(actions.openCategoryTimeDialog);
  yield take(getType(category ? actions.closeCategoryTimeDialog : actions.closeNewEstimateDialog));
}
